import React, { useContext } from "react";
import styled from "styled-components";
import Typed from "react-typed";
import { Link } from "react-router-dom";

//
import AuthContext from "../../../../../context/auth/AuthContext";
import CourseContext from "../../../../../context/course/CourseContext";
import learn from "../../../../../assets/images/learn.webp";

export default function Learn() {
  // context
  const {
    state: { isAuth },
  } = useContext(AuthContext);
  const {
    state: { courses },
  } = useContext(CourseContext);

  // methods
  function getCourseTitleList() {
    if (!courses.length)
      return [
        "Racket",
        "Clojure",
        "C#",
        "HTML",
        "GO",
        "Python",
        "PHP",
        "Си",
        "Ruby",
        "Java",
        "Javascript",
        "Elixir",
        "CSS",
      ];
    return courses.map((i) => i.content);
  }

  return (
    <StyledLearn className="learn_section">
      <div className="container">
        <div className="learn">
          <div className="learn_row">
            <div className="learn_info">
              <h6 className="learn_subTitle">
                Бесплатные курсы программирования
              </h6>
              <div className="learn_title">
                Изучи
                <Typed
                  strings={getCourseTitleList()}
                  typeSpeed={50}
                  backSpeed={50}
                  // attr="placeholder"
                  loop
                  smartBackspace
                  className="text-typed"
                >
                  <input type="text" />
                </Typed>
              </div>
              <p className="learn_lead">
                Самый быстрый способ попробовать программирование прямо в
                браузере. Бесплатные курсы с тренажером. Практика после каждого
                урока
              </p>
              {isAuth ? (
                <a href="/#course__section" className="learn_btn">
                  Попробовать
                </a>
              ) : (
                <Link to={"/auth/register"} className="learn_btn">
                  Попробовать
                </Link>
              )}
            </div>
            <div className="learn_img">
              <img src={learn} height="356" width="720" alt="learn" />
            </div>
          </div>
        </div>
      </div>
    </StyledLearn>
  );
}

const StyledLearn = styled.div`
  .learn {
    display: flex;
    box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%);
    border-radius: 0.3rem;
    position: relative;
    overflow: hidden;
    background: rgba(255, 255, 255, 1);
  }

  .learn_row {
    position: relative;
    width: 100%;
    padding: 3rem;
  }

  .learn_badge {
    display: inline-block;
    padding: 0.35em 0.65em;
    font-size: 0.75em;
    font-weight: 700;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
    border: 1px solid #dee2e6;
    color: rgba(33, 37, 41, 1);
  }
  .learn_info {
    padding: 16px 48px 84px 24px;
    width: 58.3%;
    margin: 0 12px;
  }
  .learn_subTitle {
    color: #6c757d;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 8px;
  }
  .learn_title {
    font-size: 3.5rem;
    line-height: 1;
    font-weight: 700;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;

    .text-typed > input {
      color: #0d6efd;
      margin-left: 10px;
      font-size: 3.5rem;
      line-height: 1;
      font-weight: 700;
    }
  }
  .learn_lead {
    font-size: 1.25rem;
    font-weight: 300;
    line-height: 1.5;
    margin-bottom: 1rem;
  }
  .learn .learn_lead {
    font-weight: 400;
  }
  .learn_btn {
    color: #fff;
    background-color: #0d6efd;
    border-color: #0d6efd;
    padding: 0.5rem 1.5rem;
    font-size: 1.25rem;
    border-radius: 0.3rem;
    font-weight: 700;
    display: inline-block;
    line-height: 1.5;
    cursor: pointer;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    margin-bottom: 1rem;
  }
  .learn_btn:hover {
    color: #fff;
    background-color: #0b5ed7;
    border-color: #0a58ca;
  }

  .learn_img {
    position: absolute;
    right: -300px;
    bottom: 0;
    box-shadow: 0 1rem 3rem rgb(0 0 0 / 18%);
  }

  @media (max-width: 1191px) {
    .learn_img {
      right: -416px;
    }
    .learn_info {
      padding-bottom: 48px;
    }
  }

  @media (max-width: 991px) {
    .learn_row {
      flex-direction: column;
      padding: 2rem;
    }
    .learn_img {
      position: static;
    }

    .learn_info {
      padding: 10px;
      width: 100%;
      margin: 0;
    }

    .learn_title {
      font-size: calc(1.475rem + 2.7vw);

      .text-typed input {
        font-size: calc(1.475rem + 2.7vw);
      }
    }
  }

  @media (max-width: 567px) {
    .learn_btn {
      width: 100%;
      text-align: center;
    }
    .learn_info {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;
